$(document).ready(function() {
    $('.hamburger').click(function(){
        $('.main-menu').fadeToggle();
    });
});
